export default {
	countries(state) {
		return state.countries
	},
	categories(state) {
		return state.categories
	},
	carriages(state) {
		return state.carriages
	},
	packages(state) {
		return state.packages
	},
	containers(state) {
		return state.containers
	},
	vehicles(state) {
		return state.vehicles
	},
	business(state) {
		return state.business
	},
	erpTypes(state) {
		// 1. 默认 2 FBA 3。 马帮 4。 领星  5 店小蜜
		return state.erpTypes
	}
}